// @ts-ignore
import murmurHash from "imurmurhash";

export function getHash(string: string): string {
  return murmurHash(string.trim()).result().toString();
}
